<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
    >
      <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumn"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.minWidth"
        :align="item.align"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'status'">
            <el-tag v-if="scope.row.status === 1" size="mini" type="success">
              {{ $t('GlobalSetObj.enable') }}
            </el-tag>
            <el-tag v-if="scope.row.status === 0" size="mini" type="danger">
              {{ $t('GlobalSetObj.disable') }}
            </el-tag>
            <el-tag v-if="scope.row.status === 2" size="mini" type="info">
              {{ $t('collectionCenter.Stored') }}
            </el-tag>
          </div>
          <div v-else>
            {{ scope.row[item.prop] || '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('operationCenter.operate')"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-permit:remove="'btn:invoiceCenter:pushConfiguration:view'"
            type="text"
            size="mini"
            @click="handleView(scope.row)"
          >
            <span style="color:#409eff !important;">{{ $t('GlobalSetObj.View') }}</span>
          </el-button>
          <el-button
            v-if="scope.row.status === 0 || scope.row.status === 2"
            v-permit:remove="'btn:invoiceCenter:pushConfiguration:edit'"
            type="text"
            size="mini"
            @click="handleEdit(scope.row)"
          >
            <span style="color:#409eff !important;">{{ $t('GlobalSetObj.edit') }}</span>
          </el-button>
          <el-button
            v-if="scope.row.status === 0 || scope.row.status === 2"
            v-permit:remove="'btn:invoiceCenter:pushConfiguration:updateStatus'"
            type="text"
            size="mini"
            @click="handleUpdateStatus(scope.row)"
          >
            {{ $t('GlobalSetObj.enable') }}
          </el-button>
          <el-button
            v-if="scope.row.status === 1"
            v-permit:remove="'btn:invoiceCenter:pushConfiguration:updateStatus'"
            type="text"
            size="mini"
            @click="handleUpdateStatus(scope.row)"
          >
            <span style="color: #cb272d !important;">{{ $t('GlobalSetObj.disable') }}</span>
          </el-button>
          <!--          <el-button-->
          <!--            v-if="scope.row.status === 1"-->
          <!--            v-permit:remove="'btn:invoiceCenter:pushConfiguration:temporaryStorage'"-->
          <!--            type="text"-->
          <!--            size="mini"-->
          <!--            @click="handleTemporaryStorage(scope.row)"-->
          <!--          >-->
          <!--            <span style="color: #666 !important;">{{ $t('collectionCenter.Stored') }}</span>-->
          <!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { airlinePushConfigUpdateStatus } from '@/api/invoiceCenter';

export default {
  name: 'TableColumn',
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableColumn: [
        {
          label: this.$t('mdfeTranslate.Airline'), // 航空公司
          prop: 'airlineName',
          minWidth: 180
        },
        {
          label: this.$t('compensationManagement.PaymentMethod'), // 支付方式
          prop: 'formaPagamento',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.ServiceCode'), // 服务代码
          prop: 'siglaServico',
          minWidth: 180
        },
        // {
        //   label: this.$t('mdfeTranslate.SenderName'), // 发货方名称
        //   prop: 'senderName',
        //   minWidth: 200
        // },
        {
          label: this.$t('collectionCenter.stateZT'), // 状态
          prop: 'status',
          minWidth: 160,
          align: 'center'
        },
        {
          label: this.$t('collectionCenter.ModifiedBy'), // 修改人
          prop: 'updateUserName',
          minWidth: 180
        },
        {
          label: this.$t('collectionCenter.ModificationTime'), // 修改时间
          prop: 'updateTime',
          minWidth: 180
        }
      ]
    };
  },
  methods: {
    handleView(row) {
      console.log(row);
      this.$emit('editView', row, 1);
    },
    handleEdit(row) {
      console.log(row);
      this.$emit('editView', row, 2);
    },
    handleUpdateStatus(row) {
      const tipsText = row.status === 1 ? this.$t('mdfeTranslate.AreYouSureToDisableThisAirlineConfiguration') : this.$t('mdfeTranslate.AreYouSureToEnableThisAirlineConfiguration');
      this.$confirm(tipsText, this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(() => {
        const param = {
          configCode: row.configCode,
          status: row.status === 0 ? 1 : 0
        };
        airlinePushConfigUpdateStatus(param).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: this.$t('GlobalSetObj.TheOperationSucceeded')
            });
            this.$emit('closeUpdate', true);
          }
        });
      }).catch(() => {});
    },
    handleTemporaryStorage(row) {
      console.log(row);
      this.$confirm(this.$t('mdfeTranslate.AreYouSureToSaveAsADraft'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('GlobalSetObj.TheOperationSucceeded')
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>

</style>
